/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_apex_page_of = /** @type {(inputs: { current: NonNullable<unknown>, total: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Page ${i?.current} of ${i?.total}`)
};

const es_f1_apex_page_of = /** @type {(inputs: { current: NonNullable<unknown>, total: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Página ${i?.current} de ${i?.total}`)
};

const de_f1_apex_page_of = /** @type {(inputs: { current: NonNullable<unknown>, total: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seite ${i?.current} von ${i?.total}`)
};

const nl_f1_apex_page_of = /** @type {(inputs: { current: NonNullable<unknown>, total: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pagina ${i?.current} van ${i?.total}`)
};

const fr_f1_apex_page_of = /** @type {(inputs: { current: NonNullable<unknown>, total: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Page ${i?.current} sur ${i?.total}`)
};

const it_f1_apex_page_of = /** @type {(inputs: { current: NonNullable<unknown>, total: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pagina ${i?.current} di ${i?.total}`)
};

const pt_br2_f1_apex_page_of = /** @type {(inputs: { current: NonNullable<unknown>, total: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Página ${i?.current} de ${i?.total}`)
};

const pt_f1_apex_page_of = /** @type {(inputs: { current: NonNullable<unknown>, total: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Página ${i?.current} de ${i?.total}`)
};

const ja_f1_apex_page_of = /** @type {(inputs: { current: NonNullable<unknown>, total: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.current}/${i?.total}ページ`)
};

const zh_f1_apex_page_of = /** @type {(inputs: { current: NonNullable<unknown>, total: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`第${i?.current}页，共${i?.total}页`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_apex_page_of = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_apex_page_of(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_apex_page_of", locale)
	if (locale === "en") return en_f1_apex_page_of(inputs)
	if (locale === "es") return es_f1_apex_page_of(inputs)
	if (locale === "de") return de_f1_apex_page_of(inputs)
	if (locale === "nl") return nl_f1_apex_page_of(inputs)
	if (locale === "fr") return fr_f1_apex_page_of(inputs)
	if (locale === "it") return it_f1_apex_page_of(inputs)
	if (locale === "pt-BR") return pt_br2_f1_apex_page_of(inputs)
	if (locale === "pt") return pt_f1_apex_page_of(inputs)
	if (locale === "ja") return ja_f1_apex_page_of(inputs)
	return zh_f1_apex_page_of(inputs)
};